import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment-timezone';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LiveMeetingInt, Minutes, Tag } from '../../assets/constants/constants.ts';
import { AppContext } from '../../context/AppProvider.tsx';
import useCalendar from '../../hooks/useCalendar.tsx';
import { apis } from '../../services/alm';
import DialogModalBody from "./DialogModalBody.tsx";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
} from "alm-react-components";
import useAlmCorporateStatus from '../../hooks/useAlmCorporateStatus.ts';
 
const MeetingCalendar = () => {
  const navigate = useNavigate();
  const {state} = useContext(AppContext);
  const {t} = useTranslation();
  const {meetData} = useCalendar(state?.user?.userId);
  const now = new Date();
  const nextMeeting = (meetData || []).find(
    (meeting: any) => new Date(meeting.attributes.dateEnd) > now
  );
  // const dateEnd = nextMeeting?.attributes?.dateEnd || null;
  const dateStart = nextMeeting?.attributes?.dateStart || null;
  const courseId = nextMeeting?.relationships?.course?.data?.id || null;
  const course_Id = courseId?.split(':')[1] || null;
  const [isStartMeeting, setIsStartMeeting] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [programData, setProgramData] = useState<any>(null);
  // const startTime = covertDateUtcToIST(dateStart, state?.user?.timeZoneCode);
  // const endTime = covertDateUtcToIST(dateEnd, state?.user?.timeZoneCode);
  const [joinLiveMeeting, setJoinLiveMeeting] = useState<boolean>(false);
  useAlmCorporateStatus();

  // const startBeforeFifteenMinutes = moment(startTime).subtract(LiveMeetingInt, Minutes);

  // const isBetween = () => {
  //   const datetimeNow = moment();
  //   const formattedDateTime = datetimeNow.toISOString(); 
  //   const datetimeZone=covertDateUtcToIST(formattedDateTime, state?.user?.timeZoneCode);
  //   return moment(datetimeZone.format(moment.HTML5_FMT.DATETIME_LOCAL)).isBetween(
  //     startBeforeFifteenMinutes?.format(moment.HTML5_FMT.DATETIME_LOCAL),
  //     endTime?.format(moment.HTML5_FMT.DATETIME_LOCAL)
  //   );
  // };

  // jira -HS-1474
  // Get the dates and convert into local time zone
  const startTime = moment(new Date(nextMeeting?.attributes?.dateStart)).utc().toDate() //original API response
  const endTime = moment(new Date(nextMeeting?.attributes?.dateEnd)).utc().toDate()//original API response
  const startTimeLocal = moment(new Date(startTime)); //convert startTimeUTC to local timezone and use for display

  const isBetween = () => {
    const currentUTCtime = moment.utc().toDate() //Current UTC time
    const startBeforeFifteenMint = moment(startTime).subtract(LiveMeetingInt, Minutes).utc().toDate();//startTimeUTC - 15 mins
    return moment(currentUTCtime).isBetween(startBeforeFifteenMint,endTime);
  };
  useEffect(() => {
    if(isStartMeeting === false ) { 
      setJoinLiveMeeting(false);
      setIsStartMeeting(false);
    }
  }, [isStartMeeting]);

  const checkMeating = () => {
   const intervalId= setInterval(() => {
      setIsLoading(true)
      setIsStartMeeting(isBetween());
      setJoinLiveMeeting(isBetween());
    },2000);
    return intervalId
  };

  useEffect(() => {
    let intevalId:any;
    if (dateStart) {
      setJoinLiveMeeting(isBetween());
      intevalId= checkMeating()
    }
    return ()=>{
clearInterval(intevalId)
    }
  }, [dateStart]);

  useEffect(() => {
    const getCourseDetail = async () => {
      if (course_Id) {
        try {
          const apiResponseData = await apis.getProgramDetailByCourseId(course_Id);
          setProgramData(apiResponseData.data); 
        } catch (error) {
          console.error('Error fetching fundamental program list:', error);
        }
      }
    };
    getCourseDetail();
  }, [course_Id]);

  const extractProgramIds = (data: any): { pId: string | null } => {
    let pId: string | null = null;
    data.forEach((obj: any) => {      
      if (obj.attributes.tags && obj.attributes.tags.includes(Tag.mainProgram)) {
        pId = obj.id;
      }
    });
    return { pId };
  }
  const getWeekIds = (data: any[]) => {
    return data
      .map((currentItem, currentIndex) => {
        const currentId = currentItem.id;
          const allSubLOIds = data
          .filter((_, index) => index !== currentIndex)
          .flatMap((item) => item.relationships?.subLOs?.data.map((subLO: any) => subLO.id) || []);
          const week_id = allSubLOIds.includes(currentId);
  
        return week_id ? currentId : null;
      })
      .filter((id) => id !== null);
  };

  const onClickCalenderBtn = async() => {
   const weekId =getWeekIds(programData);
   const { pId } = extractProgramIds(programData);
    if(joinLiveMeeting ){
      navigate(`/course-detail/${pId}/${weekId}/${courseId}`);
    }else{
      dispalyPopup(true)
    }
  };
  const dispalyPopup = (flag: boolean) => {
    setShowPopup(flag);
  };
  return (
    <div className="min-w-0 relative flex-1 md:flex md:items-center">
      {dateStart !== null && isLoading && (
        <div 
        onClick={() => onClickCalenderBtn()}
         className="flex md:flex items-center dark:bg-white dark:text-black rounded font-barlowMedium font-medium text-lg px-4 py-1 w-[max-content] md:m-[unset] relative md:w-auto lg:w-auto  cursor-pointer">
          <div className="flex items-center">
          <p className={`w-[12px] h-[12px] rounded-full bg-red-500  ${
                joinLiveMeeting === true ? "w-[8px] h-[8px] circle mr-3 mx-2 absolute top-[18px] left-[8px] max-sm:top-[14px]" : 'w-[14px] h-[14px] mx-1 absolute top-[12px] left-[5px] max-sm:top-[11px] '
              } `}
            ></p>
            <p className={`ml-4 max-sm:text-[15px]`}>
            {joinLiveMeeting === true  && t("Common.joinLiveMeeting")}
            {joinLiveMeeting === false &&  t("Common.nextLiveMeeting")}
            </p>
          </div>
          <span className="mx-2 font-barlowRegular font-normal text-base">
            <FontAwesomeIcon icon={faArrowRight} className=" mx-2 text-[10px] font-light" />
          </span>
          <span className="font-barlowRegular font-normal text-base max-sm:text-[15px]">
            {/* Feb. 20, 12pm. ET */}
           <span className="capitalize">
              {startTimeLocal?.format("MMM. DD, HH:mm").replace("..", ".")}
            </span>
          </span>
        </div>
      )}
        <div>
        <AlertDialog open={showPopup}>
          <AlertDialogContent className="bg-[#16171C] py-6 px-6 w-full text-center border border-primary overflow-hidden">
            <AlertDialogDescription className="flex max-sm:h-40 md:h-24 flex-col">
              <DialogModalBody
              title={t("Common.meetingNotStarted")}
              />
            </AlertDialogDescription>
            <AlertDialogFooter className="lg:justify-center z-[1]">
              <AlertDialogAction
                onClick={() => dispalyPopup(false)}
                className="w-full font-opensansSemiBold text-base capitalize"
              >
                {" "}
                {t("Common.cancel")}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </div>

  );
};

export default MeetingCalendar;